module.exports = {
  "newsAndInformation": {
    newsAndInformation: "新闻资讯",
    newsAndInformationList: "新闻资讯列表",
    title: "新闻标题",
    titleHint: "请输入新闻标题",
    type: "新闻类型",
    type0: "公司动态",
    type1: "心理新闻",
    type2: "政府心理政策",
    type3: "心理咨询常见问题",
    typeHint: "请选择新闻类型",
    deleteHint: "删除该新闻资讯后，将不可恢复，请谨慎操作！",
    addNewsAndInformation: "新增资讯",
    editNewsAndInformation: "编辑资讯",
    information: "基本信息",
    details: "资讯详情",
    detailsHint: "请输入资讯详情",
    abstract: "资讯摘要",
    abstractHint: ' 请输入资讯摘要',
    baidUoptimization: "百度优化",
    browserTitle: "浏览器标题",
    browserTitleHint: "请输入浏览器标题",
    keyword: "详情页关键字",
    keywordHint: "多个用逗号隔开",
    describe: "详情页描述",
    describeHint: "请输入详情页描述",
    cover: "封面"
  },
};



// WEBPACK FOOTER //
// ./src/i18n/newsAndInformation/zh-CN.js